import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {};
const mutations = {};
const getters = {};
const actions = {
    getCommonAd ({ rootState }, opt) {
        // 获取广告（typeid类型 0：小程序首页顶部、1：小程序供需页、2：展商中心顶部）
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/exhibitionBanner/GetByType?exhibitionId=${opt.id}&typeid=${opt.typeid}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addCommonAd ({ rootState }, opt) {
        // 新增广告
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/exhibitionBanner`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editCommonAd ({ rootState }, opt) {
        // 编辑广告
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/exhibitionBanner`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delCommonAd ({ rootState }, id) {
        // 删除广告
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/exhibitionBanner?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getCommonEntrance ({ rootState }) {
        // 获取首页快捷入口
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Quick/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addEntrance ({ rootState }, opt) {
        // 新增快捷入口
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/Quick`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editEntrance ({ rootState }, opt) {
        // 编辑快捷入口
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/Quick`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delEntrance ({ rootState }, id) {
        // 删除快捷入口
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/Quick?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getContactUsGroup ({ rootState }) {
        // 获取客服类型
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ContactUs/Group`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getContactUsByGroup ({ rootState }) {
        // 获取客服类型对应的联系人
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ContactUs/GetForGroup?isContainsEn=true`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getContactUs ({ rootState }) {
        // 获取所有客服
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ContactUs/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addContactUs ({ rootState }, opt) {
        // 新增客服
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ContactUs`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editContactUs ({ rootState }, opt) {
        // 编辑客服
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/ContactUs`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delContactUs ({ rootState }, id) {
        // 删除客服
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/ContactUs?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getAudienceAd ({ rootState }) {
        // 获取观众中心网站banner
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Banner/all`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addAudienceAd ({ rootState }, opt) {
        // 新增观众中心网站banner
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/Banner`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editAudienceAd ({ rootState }, opt) {
        // 编辑观众中心网站banner
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/Banner`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delAudienceAd ({ rootState }, id) {
        // 删除观众中心网站banner
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/Banner?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getSharePoster ({ rootState }, id) {
        // 获取展会下的海报模板
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ExhibitionSharePoster/GetByExhibition?exhibitionId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getSharePosterDetail ({ rootState }, id) {
        // 获取模板详情
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ExhibitionSharePoster?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addSharePoster ({ rootState }, opt) {
        // 新增海报模板
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ExhibitionSharePoster`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editSharePoster ({ rootState }, opt) {
        // 编辑海报模板
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/ExhibitionSharePoster`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getTask ({ rootState }, id) {
        // 获取任务
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ExportTask/GetByExhibitionId?itemId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getTaskByType ({ rootState }, opt) {
        // 获取任务
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ExportTask/GetByExhibitionId2`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addTask ({ rootState }, opt) {
        // 新增任务
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ExportTask`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    // --------------------------------------------- 参展申请 ------------------------------------------------
    getGroup ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DePjNameGroup/GetList`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    updateNetImg ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DePjName/UpdateNetImg`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getServiceByName ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ApplyExhibitionFile/GetByName`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                    if (data.status === 204) {
                        resolve("No Content");
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addService ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ApplyExhibitionFile`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    putService ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/ApplyExhibitionFile`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getApplyList ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ApplyCompanyOrder/GetShowPagedList`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getApplyList2 ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ApplyCompanyOrder/GetShowPagedList2`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    putApplyState ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/ApplyCompanyOrder/SetRowState`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getMarathon ({ rootState }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/TopicalSubject/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    addMarathon ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/TopicalSubject`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    putMarathon ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/TopicalSubject`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delMarathon ({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/TopicalSubject?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    // 证件申请
    getApplyCert ({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/DeExCardDown/GetDeExCardDownAuditList?ExhibitionId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    auditApplyCert ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/DeExCardDown/Verify`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getIDcheck ({ rootState }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/IDCard/GetRecord`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    setApplyConfig ({ rootState }, opt) {
        //修改报名表下载地址
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/ApplyConfig`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    // 参展申请 - 获取申请表下载地址n
    getApplyConfig ({ rootState }, key) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ApplyConfig/GetConfig`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    // 参展申请 - 获取申请表
    getwordfile ({ rootState }, key) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/file?key=${key}`, { responseType: "arraybuffer", ...rootState.header })
                .then(data => {
                    if (data.data) {
                        const aLink = document.createElement("a");
                        let blob = new Blob([data.data], { type: "application/msword" });
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", "预览展商申请意向表" + ".doc"); // 设置下载文件名称
                        aLink.click();
                        //document.body.appendChild(aLink)
                        this.$refs.loadElement.appendChild(aLink);

                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getSearch ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/Search/GetKeysStatisticsByAgentId`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCallingCardStatistics ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/GetCallingCardStatistics`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取洽谈目标数量
    getCategoryContent ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/GetStatisticsGroupBySourceLinkTypeCount`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取洽谈类别数量
    getStatisticsGroupByTalkTypeCount ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/GetStatisticsGroupByTalkTypeCount`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取访问总人次
    getPeopleNumber ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VisitLog/GetStatisticsGroupByTargetTypeCount`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取访问总人数
    getPersonNumber ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VisitLog/GetStatisticsGroupByTargetTypeAndUserIdCount`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //查询渠道列表
    getChannelList ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/WeAppSmallCode/GetListSpectatorChannel`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //添加渠道
    AddChannel ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/WeAppSmallCode?targetType=4&Name=${opt.name}`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //添加渠道
    pdfToImages ({ rootState }, url) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/file/pdf-to-images?url=${url}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });


    },
    // /api/Exhibition/GetBakeryTotalById
    getBakeryTotalById ({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Exhibition/GetBakeryTotalById?Id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
